import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const list = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/noteTags`, {
		branchId,
	});
};

const find = (merchantId, branchId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/noteTags/${id}`, {
		branchId,
	});
};

const create = (merchantId, branchId, name, operateBy) => {
	return Client.post(`${baseUrl}/${merchantId}/noteTags`, {
		branchId,
		name,
		operateBy,
		stopFlag: 0,
	});
};

const update = (merchantId, branchId, id, name, operateBy) => {
	return Client.put(`${baseUrl}/${merchantId}/noteTags/${id}`, {
		branchId,
		name,
		operateBy,
		stopFlag: 0,
	});
};

const remove = (merchantId, branchId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/noteTags/${id}`, {
		branchId,
		operateBy,
	});
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
